var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveMithunSociety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_159",
    "data-name": "Ellipse 159",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(26 549)",
    fill: "#B1040E"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(-26 -549)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_01-home",
    "data-name": "01-home",
    transform: "translate(31.268 552.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M10.827.206A7.741,7.741,0,0,0,3.1,7.938c0,2.071,1.255,4.731,3.729,7.9A42.044,42.044,0,0,0,10.5,19.957a.473.473,0,0,0,.654,0,42.045,42.045,0,0,0,3.675-4.114c2.475-3.174,3.729-5.834,3.729-7.9A7.741,7.741,0,0,0,10.827.206Zm0,13.255A5.523,5.523,0,1,1,16.35,7.938,5.529,5.529,0,0,1,10.827,13.461Z",
    transform: "translate(-3.095 -0.206)",
    fill: "#B1040E"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "c",
    transform: "translate(39 562)",
    fill: "#B1040E",
    fontSize: 9,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2,
    y: 0
  }, "c")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMithunSociety);
export default __webpack_public_path__ + "static/media/activeMithunSociety.1cc7172bd25eb743889d3d2e0c509766.svg";
export { ForwardRef as ReactComponent };